import { render, staticRenderFns } from "./RolesSelect.vue?vue&type=template&id=f4ec21c8&"
import script from "./RolesSelect.vue?vue&type=script&lang=js&"
export * from "./RolesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports